export const en = {
    'choose-goal': 'Choose a goal',
    'involved-sessions': 'Engaged sessions',
    'less-then-min-conversion': 'The conversion value must be at least {currencySymbol}{minConversion}',
    'more-then-max-conversion': 'The conversion value is too high',
    'not-chosen-goal': 'Select a goal',
    'unavailable-goal': 'Goal not found'
};
